import { useTranslation } from 'react-i18next';
import { DeleteButton } from '../../../../components/buttons/DeleteButton';

export const RecipeOutputTable = ({ items, onRemove }) => {
    const { t } = useTranslation('recipe');

    const handleRemove = (item) => {
        onRemove(item);
    };

    return (
        <table id={'recipe-output-table'}>
            <thead>
            <tr>
                <th className={'td center'}>{t('output.title')}</th>
                <th className={'td center'}>{t('output.output')}</th>
                <th className={'td center'}></th>
            </tr>
            </thead>
            <tbody>
            {items != null && items.length > 0 ? items.map((output, index) => {
                return (
                    <tr key={index}>
                        <td className={'td'}> {output.title}</td>
                        <td className={'td center'}>{output.amountGrams}</td>
                        <td className={'td'}><DeleteButton onClick={() => handleRemove(output.idx)} /></td>
                    </tr>
                );
            }) : <></>}
            </tbody>
        </table>
    );
};